export default __webpack_public_path__ + "static/media/USParks.8f120c27.png";